// extracted by mini-css-extract-plugin
export default {"ace-c-service-category-title":"service-category-title---e279becf","ace-c-service-category-title__icon":"service-category-title__icon---83f47d1c"};